import { render, staticRenderFns } from "./ReSearchMObjSmall.vue?vue&type=template&id=0a98eed1&scoped=true"
import script from "./ReSearchMObjSmall.vue?vue&type=script&lang=js"
export * from "./ReSearchMObjSmall.vue?vue&type=script&lang=js"
import style0 from "./ReSearchMObjSmall.vue?vue&type=style&index=0&id=0a98eed1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a98eed1",
  null
  
)

export default component.exports